export default "__VITE_ASSET__DbP_FEea__"